import "core-js/modules/es.string.trim.js";
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1529249d"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["id", "data-cy", "rows", "disabled", "aria-labelledby", "innerHTML"];
var _hoisted_2 = {
  key: 0,
  "class": "tw-float-none tw-w-auto tw-overflow-hidden tw-block tw-p-0 tw-text tw-ml-2 tw-h-3 tw-visible tw-max-w-full tw-ease-out tw-duration-[50s] tw-whitespace-nowrap"
};
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_floating_label = _resolveComponent("base-floating-label");
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass(_ctx.$attrs['wrapper-classes'])
  }, [_createElementVNode("div", {
    "class": _normalizeClass(["input-wrapper tw-relative tw-mt-15px tw-px-0 tw-rounded-xs", [_ctx.labelState === 'floating-label' ? 'floating-state' : 'inline-state']])
  }, [_createElementVNode("textarea", {
    id: _ctx.$attrs.id,
    ref: "textarea",
    "data-cy": _ctx.$attrs['data-cy'],
    "class": _normalizeClass(["textarea-scrollbar tw-bg-white tw-pt-15px tw-px-15px tw-pb-[8px] tw-w-full tw-peer/fieldset tw-bg-no-repeat tw-whitespace-pre-wrap tw-overflow-y-auto tw-border-0 tw-rounded-xs tw-outline-none", [{
      '!tw-bg-w-cultured': _ctx.$attrs.disabled || _ctx.isDisabled
    }, {
      'is-invalid invalid-bg !tw-pr-10': _ctx.isValid === false
    }, {
      'is-valid valid-bg !tw-pr-10': _ctx.isValid
    }, {
      'tw-resize-none': !_ctx.resize
    }]]),
    rows: _ctx.$attrs.rows,
    disabled: _ctx.$attrs.disabled,
    "aria-labelledby": _ctx.$attrs.id,
    onFocusin: _cache[0] || (_cache[0] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.handleFocusIn && _ctx.handleFocusIn.apply(_ctx, arguments);
    }, ["stop"])),
    onFocusout: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
      return _ctx.handleFocusOut("".concat(_ctx.modelValue).trim() || _ctx.value);
    }, ["stop"])),
    onInput: _cache[2] || (_cache[2] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.handleOnChange && _ctx.handleOnChange.apply(_ctx, arguments);
    }, ["stop"])),
    onKeydown: _cache[3] || (_cache[3] = _withModifiers(function () {}, ["stop"])),
    innerHTML: _ctx.modelValue
  }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1), _createElementVNode("fieldset", {
    "class": _normalizeClass(["tw-absolute tw-text-start tw-m-0 tw-pointer-events-none tw-overflow-hidden tw-transition-[border] tw-duration-100 tw-ease-out tw-right-0 tw-bottom-5px tw-left-0 -tw-top-5px tw-px-2 tw-min-w-0 tw-border-solid tw-border tw-rounded-xs peer-focus/fieldset:tw-border-2 peer-focus/fieldset:tw-border-w-primary", [{
      'is-invalid': _ctx.isValid === false,
      'is-valid': _ctx.isValid
    }, {
      'tw-border-w-danger': _ctx.isValid === false
    }, {
      'tw-border-w-primary': _ctx.isValid
    }, {
      'tw-border-w-secondary': _ctx.isValid === null
    }]])
  }, [_ctx.labelText ? (_openBlock(), _createElementBlock("legend", _hoisted_2, [_createElementVNode("span", {
    "class": _normalizeClass(["tw-px-5px tw-opacity-0", [{
      'tw-visible tw-inline-block': _ctx.labelState === 'floating-label'
    }, {
      'tw-invisible tw-hidden': _ctx.labelState === 'inline-label'
    }]]),
    innerHTML: _ctx.labelText
  }, null, 10 /* CLASS, PROPS */, _hoisted_3)])) : _createCommentVNode("v-if", true)], 2 /* CLASS */), _createVNode(_component_base_floating_label, {
    "for": _ctx.$attrs.id,
    "label-text": _ctx.labelText,
    "label-state": _ctx.labelState,
    required: _ctx.$attrs.required,
    "is-valid": _ctx.isValid,
    onClick: _ctx.handleFloatingLabelClick
  }, null, 8 /* PROPS */, ["for", "label-text", "label-state", "required", "is-valid", "onClick"])], 2 /* CLASS */), (_ctx.isValid || _ctx.isValid === false) && _ctx.feedback ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass(_ctx.isValid === false ? 'tw-text-w-danger tw-text-12 tw-mt-1' : 'tw-text-w-primary tw-text-12 tw-mt-1'),
    innerHTML: _ctx.isValid === false ? _ctx.feedback.invalid : _ctx.feedback.valid
  }, null, 10 /* CLASS, PROPS */, _hoisted_4)) : _createCommentVNode("v-if", true)], 2 /* CLASS */);
}